<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false; dialog.form = true;"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          {{ files[selected.file].text }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false; dialog.form = form.id === '' ? true : false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <div v-if="selected.file == 0">
              <div
                class="body-2 font-italic mb-2">
                Silahkan upload data dokumen dengan format PDF:
              </div>

              <uploaddocument 
                v-model="upload.doc">
                <div slot="activator">
                  <v-btn
                    :disabled="process.doc"
                    :loading="process.doc"
                    block
                    height="40"
                    :color="`${set_color_rgb_down}`"
                    elevation="0"
                    class="body-2 font-weight-bold text-capitalize d-flex align-center mb-4"
                    :style="`color: ${set_color};`"
                    style="border-radius: 10px;">
                    <v-icon>mdi-file-pdf-box</v-icon>

                    <span
                      class="ml-2">
                      Upload Data PDF
                    </span>
                  </v-btn>
                </div>
              </uploaddocument>

              <v-card v-if="form.url !== ''"
                flat
                style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                <div
                  ref="arsippdf">
                  <iframe
                    :src="`${form.url}#toolbar=0`" 
                    allowfullscreen
                    frameborder="0" 
                    width="100%"
                    height="750"
                    style="border-radius: 10px; border: 2px solid #323639;">
                  </iframe>
                </div>
              </v-card>
            </div>

            <div v-if="selected.file == 1">
              <div
                class="body-2 font-italic mb-2">
                Silahkan upload data dokumen dengan format Gambar:
              </div>

              <uploadimage
                v-model="upload.image">
                <div slot="activator">
                  <v-btn
                    :disabled="process.image"
                    :loading="process.image"
                    block
                    height="40"
                    :color="`${set_color_rgb_down}`"
                    elevation="0"
                    class="body-2 font-weight-bold text-capitalize d-flex align-center mb-4"
                    :style="`color: ${set_color};`"
                    style="border-radius: 10px;">
                    <v-icon>mdi-image-outline</v-icon>

                    <span
                      class="ml-2">
                      Upload Data Gambar
                    </span>
                  </v-btn>
                </div>
              </uploadimage>

              <v-card v-if="form.url !== ''"
                flat
                style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                <v-img 
                  contain
                  :src="form.url"
                  class="ma-auto"
                  style="border-radius: 10px;">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center">
                      <v-progress-circular 
                        indeterminate 
                        :color="set_color">
                      </v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-card>
            </div>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :loading="process.form"
            :disabled="process.form || form.url === ''"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; dialog.fullscreen = false; dialog.form = form.id === '' ? true : false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.preview"
      @keydown.esc="dialog.preview = false; dialog.preview = true;"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
          Preview Dokumen {{ files[selected.file].text }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.preview = false; dialog.fullscreen = false; dialog.preview = form.id === '' ? true : false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <div v-if="selected.file == 0">
            <v-card v-if="preview_index !== ''"
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <div
                ref="arsippdf">
                <iframe
                  :src="`${detail.file_doc_json_array[preview_index].url}#toolbar=0`" 
                  allowfullscreen
                  frameborder="0" 
                  width="100%"
                  height="750"
                  style="border-radius: 10px; border: 2px solid #323639;">
                </iframe>
              </div>
            </v-card>
          </div>

          <div v-if="selected.file == 1">
            <v-card v-if="preview_index !== ''"
              flat
              style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
              <v-img 
                contain
                :src="detail.image_doc_json_array[preview_index].url"
                class="ma-auto"
                style="border-radius: 10px;">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-card>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            @click="dialog.preview = false; dialog.fullscreen = false; preview_index = '';">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col
        class="pt-0">
        <v-tabs 
          v-model="selected.menu"
          flat
          slider-size="5"
          :color="set_color"
          class="mb-3">
          <v-tab
            class="d-flex justify-start"
            v-for="(item, index) in menu"
            :key="index"
            style="min-width: 70px;">
            <v-icon size="20" left>
              {{ item.icon }}
            </v-icon>
            
            <span 
              class="body-2 text-capitalize"
              :class="selected.menu === index ? 'font-weight-bold' : ''">
              {{ item.text }}
            </span>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row v-if="selected.menu == 0">
      <v-col
        cols="12"
        md="12"
        class="py-0">
        <v-card
          outlined
          class="pa-4"
          height="calc(100vh - 195px)"
          style="overflow-y: auto;">
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.load"
            type="image, article, list-item-two-line, article, list-item-two-line">
            <div>
              <div v-if="!process.load && Object.keys(detail).length > 0">
                <v-card
                  flat
                  class="mb-4"
                  style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                  <v-img 
                    contain
                    height="300"
                    alt="amanata" 
                    :src="detail.image_url === '' ? require('@/assets/image/image_default.png') : detail.image_url"
                    class="ma-auto"
                    style="border-radius: 10px;">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          color="white">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>

                <v-row>
                  <v-col
                    cols="12"
                    md="12">
                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        {{ detail.title }}
                      </div>

                      <div
                        class="line-text-second">
                        Dibuat {{ detail.input_datetime | date }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Indikator
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.indicator_name }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Deskripsi
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.desc }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Lokasi
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.location }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Tanggal
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.start_date | date }} <span class="mx-2">s/d</span> {{ detail.end_date | date }}
                      </div>
                    </div>

                    <div>
                      <div
                        class="body-1 font-weight-bold black--text">
                        Jam
                      </div>

                      <div
                        class="line-text-second">
                        {{ `${detail.start_time.split(':')[0]}:${detail.start_time.split(':')[1]}` }} <span class="mx-2">s/d</span> {{ `${detail.end_time.split(':')[0]}:${detail.end_time.split(':')[1]}` }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="selected.menu == 1">
      <v-col
        cols="12"
        md="12"
        class="py-0">
        <v-card
          outlined
          class="pa-4"
          height="calc(100vh - 195px)"
          style="overflow-y: auto;">
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.load"
            type="image, image, article, list-item-two-line"
            style="border-radius: 0px;">
            <div
              class="mb-8">
              <div v-if="!process.load && Object.keys(detail).length > 0"
                class="d-flex justify-center my-3">
                <qr-code 
                  id="download_qr"
                  :text="detail.uuid"
                  :size="rps !== 'lg' ? 275 : 500">
                </qr-code>
              </div>
            </div>

            <div
              class="text-center">
              <v-btn
                @click="to_download()"
                color="green"
                elevation="0"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text">
                Download QR Kode
              </v-btn>
            </div>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="selected.menu == 2">
      <v-col
        cols="12"
        class="pt-0">
        <div
          class="d-flex align-center mb-1">
          <div>
            Total Pengunjung : <strong class="black--text ml-1">{{ detail.user_event.length }}</strong>
          </div>

          <v-spacer />

          <v-btn
            @click="prints()"
            :disabled="process.print"
            :loading="process.print"
            color="#444444"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text">
            <v-icon>mdi-microsoft-excel</v-icon>
            
            <span
              class="ml-1">
              Export
            </span>
          </v-btn>
        </div>

        <v-simple-table
          class="my-2"
          height="720"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Foto
                </th>
                <th class="text-left">
                  Nomor Induk Pegawai
                </th>
                <th class="text-left">
                  Unit
                </th>
                <th class="text-left">
                  Nama Lengkap
                </th>
                <th class="text-left">
                  Telepon
                </th>
                <th class="text-left">
                  Tanggal
                </th>
              </tr>
            </thead>
            
            <tbody>
              <tr
                v-for="(item, index) in detail.user_event"
                :key="index"
                style="opacity: 70%;">
                <td
                  style="border: none !important;">
                  <v-avatar
                    size="30">
                    <v-img 
                      contain
                      alt="amanata" 
                      :src="item.user_image_url !== '' ? item.user_image_url : require('@/assets/image/image_default.png')"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                </td>
                <td
                  style="border: none !important;">
                  {{ item.user_code }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.unit_name }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.user_name }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.user_mobilephone }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.created_datetime | datetime }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <v-row v-if="selected.menu == 3">
      <v-col
        cols="12"
        class="pt-0">
        <div
          class="d-flex align-center mb-3">
          <div>
            Total Dokumentasi : <strong class="black--text ml-1">{{ detail.file_doc_json_array.length + detail.image_doc_json_array.length }}</strong>
          </div>

          <v-spacer />

          <div
            class="d-flex align-center">
            <v-btn
              v-for="(item, index) in files"
              :key="index"

              @click="selected.file = index"
              elevation="0"
              width="120"
              :style="index < 1 ? 'border-radius: 50px 0px 0px 50px;' : 'border-radius: 0px 50px 50px 0px;'"
              :class="index === selected.file ? 'green--text' : 'grey--text'"
              :color="index === selected.file ? '#4caf5033' : ''"
              class="body-2 text-capitalize font-weight-bold d-flex align-center green--text">
              <v-icon size="18">{{ item.icon }}</v-icon>
              
              <span class="ml-1">
                {{ item.text }}
              </span>
            </v-btn>
          </div>
        </div>

        <v-card
          outlined
          class="pa-4"
          height="calc(100vh - 195px)"
          style="overflow-y: auto;">
          <v-btn
            @click="dialog.form = true; reset();"
            elevation="0"
            style="background: #4caf5033; border-radius: 10px;"
            class="body-2 text-capitalize font-weight-bold d-flex align-center green--text mb-2">
            <v-icon size="18">mdi-check-circle-outline</v-icon>

            <span class="ml-1">
              Tambah
            </span>
          </v-btn>

          <v-row v-if="process.load">
            <v-col
              cols="12"
              md="3"
              v-for="(item, index) in 4"
              :key="index">
              <v-skeleton-loader
                class="ma-auto"
                :loading="process.load"
                type="image">
              </v-skeleton-loader>
            </v-col>
          </v-row>

          <v-row v-if="!process.load && selected.file == 0">
            <v-col
              cols="12"
              md="3"
              v-for="(item, index) in detail.file_doc_json_array"
              :key="index">
              <v-card v-if="!process.load && detail.file_doc_json_array.length > 0"
                flat
                color="#f0f0f0"
                style="border-radius: 10px;">
                <v-list
                  flat
                  color="transparent"
                  class="py-0">
                  <v-list-item>
                    <v-list-item-avatar
                      class="ml-0 mr-2">
                      <v-icon color="red">mdi-file-pdf-box</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title 
                        class="body-2 text-capitalize">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action
                      class="ma-0 ml-2">
                      <v-menu
                        transition="slide-x-transition"
                        bottom
                        right
                        offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"

                            icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>

                        <v-list
                          dense>
                          <v-list-item
                            v-for="(item_action, index_action) in menu_action"
                            :key="index_action"
                            @click="toAction(item_action.text, index, 'pdf')"
                            class="pl-0 pr-3">
                            <v-list-item-avatar
                              class="ma-0">
                              <v-icon
                                size="20">
                                {{ item_action.icon }}
                              </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title
                                class="body-2 text-capitalize">
                                {{ item_action.text }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <v-card-text
                  class="pt-0">
                  <v-img
                    height="200"
                    :src="require('@/assets/image/word_default.jpeg')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="!process.load && selected.file == 1">
            <v-col
              cols="12"
              md="3"
              v-for="(item, index) in detail.image_doc_json_array"
              :key="index">
              <v-card v-if="!process.load && detail.image_doc_json_array.length > 0"
                flat
                color="#f0f0f0"
                style="border-radius: 10px;">
                <v-list
                  flat
                  color="transparent"
                  class="py-0">
                  <v-list-item>
                    <v-list-item-avatar
                      class="ml-0 mr-2">
                      <v-icon color="blue">mdi-image-outline</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title 
                        class="body-2 text-capitalize">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action
                      class="ma-0 ml-2">
                      <v-menu
                        transition="slide-x-transition"
                        bottom
                        right
                        offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"

                            icon>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>

                        <v-list
                          dense>
                          <v-list-item
                            v-for="(item_action, index_action) in menu_action"
                            :key="index_action"
                            @click="toAction(item_action.text, index, 'image')"
                            class="pl-0 pr-3">
                            <v-list-item-avatar
                              class="ma-0">
                              <v-icon
                                size="20">
                                {{ item_action.icon }}
                              </v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title
                                class="body-2 text-capitalize">
                                {{ item_action.text }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <v-card-text
                  class="pt-0">
                  <v-img
                    contain
                    height="200"
                    :src="item.url">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,

          form: false,
          preview: false
        },

        preview_index: '',

        selected: {
          menu: 0,

          file: 0
        },

        menu: [
          {
            icon: 'mdi-calendar-range-outline',
            text: 'Detail Event'
          },
          {
            icon: 'mdi-qrcode',
            text: 'QR Kode'
          },
          {
            icon: 'mdi-account-group-outline',
            text: 'Pengunjung'
          },
          {
            icon: 'mdi-file-document-multiple-outline',
            text: 'Dokumentasi'
          }
        ],

        files: [
          {
            icon: 'mdi-file-document-outline',
            text: 'PDF'
          },
          {
            icon: 'mdi-image-outline',
            text: 'Gambar'
          }
        ],

        menu_action: [
          {
            text: 'lihat',
            icon: 'mdi-eye-outline'
          },
          {
            text: 'hapus',
            icon: 'mdi-delete-circle-outline'
          }
        ],

        detail: {},

        form: {
          id: '',

          url: '',

          file_doc_json_array: [],
          image_doc_json_array: []
        },

        upload: {
          doc: false,
          image: false
        },

        process: {
          load: false,

          print: false,

          form: false,
          doc: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_pdf.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.48)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      }
    },
    watch: {
      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.url = this.upload.doc.fileuri

              this.form.file_doc_json_array.push({
                title: this.upload.doc.filename,
                url: this.upload.doc.fileuri,
                size: this.upload.doc.filesize,
                mimetype: this.upload.doc.filemime,
                extension: this.upload.doc.filemime.split('/')[1]
              })
            }
          }
        },
        deep: true
      },

      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.url = this.upload.image.fileuri

              this.form.image_doc_json_array.push({
                title: this.upload.image.filename,
                url: this.upload.image.fileuri,
                size: this.upload.image.filesize,
                mimetype: this.upload.image.filemime,
                extension: this.upload.image.filemime.split('/')[1]
              })
            }
          }
        },
        deep: true
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        
        let params = {
          id: this.$route.params.id
        }

        await get(`admin/event/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      to_download () {
        let img = document.querySelector("#download_qr img").src

        const a = document.createElement('a')
        a.download = `QR-Code-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.png`
        a.href = img
        a.click()
      },

      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          id: this.detail.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/event/export_participant`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Presensi-Peserta-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form = {
          id: this.detail.id,

          url: '',

          file_doc_json_array: this.detail.file_doc_json_array,
          image_doc_json_array: this.detail.image_doc_json_array
        }

        this.upload = {
          doc: false,
          image: false
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let url = this.selected.file == 0 ? 'admin/event/update_file_doc' : 'admin/event/update_image_doc'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async toAction (menu, index, type) {
        this.reset()

        if (menu === 'lihat') {
          this.preview_index = index

          this.dialog.preview = true
        } else {
          let url = type === 'pdf' ? 'admin/event/update_file_doc' : 'admin/event/update_image_doc'

          if (type === 'pdf') {
            this.form.file_doc_json_array.splice(index, 1)
          } else {
            this.form.image_doc_json_array.splice(index, 1)
          }

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>